// ══════════════════════════════════════════════════════════════
// COMPASS – Language Interceptor
// ══════════════════════════════════════════════════════════════
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { requestLanguage } from '../i18n/active-locale';

/**
 * Sends the selected language as `Accept-Language` on backend API calls, so error messages,
 * notifications and country names come back in that language. Other requests (Keycloak,
 * translation files and other assets) are left untouched.
 *
 * Reads the requestLanguage signal instead of injecting LanguageService: this interceptor also
 * runs while TranslateService loads its files, so injecting it would create a DI cycle.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  return next(req.clone({ setHeaders: { 'Accept-Language': requestLanguage() } }));
};
